export default "__VITE_ASSET__DUzCiyEY__"